import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-invoice-info" }


import ListRow from "@/components/common/list/ListRow.vue";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CardInvoiceInfo',
  props: {
    companyInvoice: {}
  },
  setup(__props: any) {

const props = __props;



const columns = [
  {
    header: "宛名",
    text: props.companyInvoice.invoice_address || "-"
  },
  {
    header: "To",
    text: props.companyInvoice.invoice_email || "-"
  },
  {
    header: "請求期日",
    text: props.companyInvoice.labels.invoice_due_date || "-"
  },
  {
    header: "振込期日",
    text: props.companyInvoice.labels.transfer_due_date || "-"
  },
  {
    header: "送付方法",
    text: props.companyInvoice.labels.invoice_shipping_method || "-"
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListRow, {
      columns: columns,
      vertical: "",
      "half-gap": ""
    })
  ]))
}
}

})